import { APIContext } from '@shared/contexts/pluginContexts/APIContext';
import { useAuthContext } from '@shared/contexts/useAuthContext';

type OutlookAPIContextProviderProps = {
  children: JSX.Element;
};
export const OutlookAPIContextProvider = ({
  children,
}: OutlookAPIContextProviderProps) => {
  const { token } = useAuthContext();
  const apiURL = import.meta.env.VITE_API_BASE_URL;
  if (!apiURL) {
    throw new Error('API URL is not defined');
  }

  function apiResolver() {
    return {
      url: apiURL,
      headers: {
        Authorization: token || '',
      },
    };
  }
  return (
    <APIContext.Provider
      value={{
        apiResolver,
      }}
    >
      {children}
    </APIContext.Provider>
  );
};
